//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ToSupport from "@/pages/build800/views/components/ToSupport";

export default {
  props: ["userName"],
  components: { ToSupport },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/Base/components/Userinfo/index.vue